import getUpdateForProperty from './getUpdateForProperty';
import Task from '../services/Task';
import Todo from '../store/schema/Todo';

export default function getPartialTaskFromTodo(
    todoUpdates: Partial<Todo>,
    ignoreNullValues?: boolean
): Partial<Task> {
    if (!todoUpdates) {
        return null;
    }

    const udpates = Object.keys(todoUpdates)
        .map((key: keyof Todo) => tryGetUpdateForProperty(key, todoUpdates[key], ignoreNullValues))
        .filter(update => !!update);

    if (udpates.length === 0) {
        return null;
    }

    const restAPIUpdates = {};
    udpates.forEach(item => {
        restAPIUpdates[item.key] = item.value;
    });

    return restAPIUpdates;
}

function tryGetUpdateForProperty(
    todoPropertyName: keyof Todo,
    value: any,
    ignoreNullValues?: boolean
) {
    if (ignoreNullValues && value === null) {
        return null;
    }

    return getUpdateForProperty(todoPropertyName, value);
}
